import { mutatorAction } from 'satcheljs';
import TabViewState from '../store/schema/TabViewState';
import { getStore } from '../store/tabStore';

export default mutatorAction('removeTabViewState', function removeTabViewState(
    viewState: TabViewState
) {
    const store = getStore();
    const index = store.tabs.indexOf(viewState);
    if (index >= 0) {
        store.tabs.splice(index, 1);
    }
});
